import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DynamicFormModule } from 'src/app/feature/dynamic-form/dynamic-form.module';
import { NotificationComponent } from './notification.component';
import { NotificationEffects } from './notification.effects';
import { notificationReducer } from './notification.reducer';

@NgModule({
	declarations: [NotificationComponent],
	imports: [
		CommonModule,
		StoreModule.forFeature('notifications', notificationReducer),
		EffectsModule.forFeature([NotificationEffects]),
		DynamicFormModule,
	],
	exports: [NotificationComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationModule {}
